import { createApp } from 'vue'
import App from './App.vue'
import MetaUI from '../../components'

import 'normalize.css/normalize.css'
import '../../style/index.scss'
import 'vant/lib/index.css'
import utils from '@/utils/index'
import LGSdk from '@/utils/languageSDK/index'
import VConsole from 'vconsole'
import { Lazyload } from 'vant'
import { useMonitor } from '@/hooks/useMonitor'

const { startMonitor } = useMonitor()

const app = createApp(App)
  .use(LGSdk)
  .use(MetaUI)
  .use(utils)
  .use(Lazyload, { lazyComponent: true })

startMonitor({
  app
})

app.mount('#dynamic')

if (['development', 'stable', 'stableMe', 'stableSa'].includes(process.env.VUE_APP_ENV || '')) {
  const vConsole = new VConsole()
  console.log(vConsole) // 添加这行代码来使用 vConsole 对象
}
